export enum AnalyticsEventName {
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  VIEW_ITEM = 'view_item',
  SEARCH = 'search',
  USER_REGISTER = 'user_register',
  USER_LOGIN = 'user_login',
  USER_DROP_OUT = 'user_drop_out',
  USER_LOGOUT = 'user_logout',
  CHECKOUT_STEP_1 = 'checkout_customer_info',
  CHECKOUT_STEP_2 = 'checkout_delivery_info',
  CHECKOUT_STEP_3 = 'checkout_delivery_option',
  CHECKOUT_STEP_4 = 'checkout_order',
}

export enum AnalyticsEventCategory {
  ECOMMERCE = 'Ecommerce',
}

export interface AnalyticsAdapter {
  init: () => void;

  trackPageView: (path: string) => void;

  trackEvent: (input: {
    action: AnalyticsEventName;
    category: AnalyticsEventCategory;
    label?: string;
    value?: number;
    params?: { [key: string]: any };
  }) => void;
}
